import { getEnvVariable } from "../../App.jsx";
import { getStoredToken } from "../constants/auth.js";

export const getSecuredFileUrl = (filePath) => {
    //Get token from Local Storage
    let url = new URL(`${import.meta.env.VITE_BASE_API_URL}/${import.meta.env.VITE_VERSION_V1}/${filePath}`)
    url.searchParams.set('token', getStoredToken())
    console.log(url);
    return url.toString()
}

export const getFilePath = (url, token) => {
    let BaseUrl = new URL(`${import.meta.env.VITE_BASE_API_URL}/${import.meta.env.VITE_VERSION_V1}/file/${token}`)
    return (`${BaseUrl}/${url}`)
}
export const viewFilePath = (url, token) => {
    let BaseUrl = new URL(`${import.meta.env.VITE_BASE_API_URL}/${import.meta.env.VITE_VERSION_V1}/file/read/${token}`)
    return (`${BaseUrl}/${url}`)
}

export const getPreviewUrl = (file, token = null) => {
    const extention = file.split('.').pop()
    switch (extention) {
        case "svg":
            return viewFilePath(file, token)
        case "png":
            return viewFilePath(file, token)
        case "jpg":
            return viewFilePath(file, token)
        case "jpeg":
            return viewFilePath(file, token)
        case "ai":
            return "/icons/filetypes/ai.svg"
        case "pdf":
            return "/icons/filetypes/pdf.svg"
        default:
            return "/icons/filetypes/file.svg"
    }
}

export const getPublicFileUrl = (file) => `${getEnvVariable('VITE_SERVER_BASE_URL')}/data/${getEnvVariable('VITE_VERSION_V1')}/${file}`

// CMS product photos are bare filenames; ERP-created products store an absolute
// URL to the ERP server's public uploads (…/data/v1/upload/…). Those are loaded
// through this portal's own server base: the portal's Content-Security-Policy
// only allows images from itself and leoprinting.nl, not the ERP host.
const ERP_UPLOAD_URL = /^https?:\/\/[^/]+\/data\/[^/]+\/(upload\/.+)$/i
export const getCmsFileUrl = (file) => {
    if (!/^https?:\/\//i.test(file ?? '')) {
        return `https://leoprinting.nl/files/photos/${file}`
    }
    const upload = file.match(ERP_UPLOAD_URL)
    return upload ? getPublicFileUrl(upload[1]) : file
}